<template>
  <div id="helia-container">
    <a-layout id="layout">
      <a-layout-header>
        <svg-icon icon-class="logo" className="logo"></svg-icon>
        <nav-bar/>
      </a-layout-header>
      <a-layout>
        <a-layout-sider class="sider"
                        collapsible
                        v-model="collapsed"
                        :trigger="null"
                        @mouseenter.native="collapsed=false"
                        @mouseleave.native="collapsed=true"
                        :width="$i18n.locale === LANGUAGE.CHINESE ? '160' : '200'"
                        collapsed-width="80">
          <side-bar :collapsed="collapsed"/>
        </a-layout-sider>
        <a-layout-content
            :style="{ background: '#fff', margin: 0, minHeight: '280px' }"
        >
          <app-main/>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { NavBar, SideBar, AppMain } from './index'
import SvgIcon from '@/components/behavior/svg-icon'
import { LANGUAGE } from '@/utils/constant'

export default {
  name: 'Layout',
  components: {
    NavBar,
    SideBar,
    AppMain,
    SvgIcon,
  },
  provide() {
    return {
      getReactiveCollapsed: () => this.collapsed
    }
  },
  data() {
    return {
      LANGUAGE: LANGUAGE,
      collapsed: true
    }
  }
}
</script>

<style scoped lang="scss">
header.ant-layout-header {
  background: white;
  height: 72px;
  border-bottom: 1px solid #EDEFF2;
  padding-left: 0;
  padding-right: 0;
}

.sider {
  background: white;
}

#helia-container {
  width: 100%;
  height: 100%;
}

#layout .logo {
  width: 83px;
  height: 21px;
  float: left;
  margin-left: 24px;
  margin-top: 25.5px;
}
</style>
